export default "__VITE_ASSET__Dmxre1Bg__"